<template>

    <form @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)" ref="form">

        <input type="hidden" name="stay-on-page" v-model="stayOnPage">

        <div class="form-group">
            <label for="name">Nazwa</label>
            <input type="text" class="form-control" id="name" v-model="form.name">
            <span class="error mt-2 text-danger" v-if="form.errors.has('name')" v-text="form.errors.get('name')"></span>
        </div>

        <div class="form-group">
            <label for="description">Opis</label>
            <textarea id="description" class="form-control" rows="3" v-model="form.description"></textarea>
            <span class="error mt-2 text-danger" v-if="form.errors.has('description')" v-text="form.errors.get('description')"></span>
        </div>

        <div class="form-group">
            <label for="users_ids">Użytkownicy</label>
            <select2 id="users_ids" :options="usersOptions" v-model="form.users_ids" multiple></select2>
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="hide_token_users" v-model="hideTokenUsers">
                <label class="custom-control-label" for="hide_token_users" style="font-size: 0.875rem; line-height: 1.6;">Ukryj użytkowników tokenowych</label>
            </div>
            <span class="error mt-2 text-danger" v-if="form.errors.has('users_ids')" v-text="form.errors.get('users_ids')"></span>
        </div>

    </form>

</template>

<script>

    export default {

        name: 'UserGroupForm',

        props: [
            'formType',
            'userGroup',
            'users'
        ],

        data() {
            let form;
            if (this.formType === 'edit') {
                form = new Vue.prototype.Form({
                    name: this.userGroup.name,
                    description: this.userGroup.description,
                    users_ids: this.userGroup.users.map(user => user.id)
                });
            } else {
                form = new Vue.prototype.Form({
                    name: '',
                    description: '',
                    users_ids: []
                });
            }
            return {
                eventHub: window.eventHub,
                form: form,
                hideTokenUsers: true,
                stayOnPage: false
            }
        },

        computed: {
            usersOptions() {
                let usersOptions = [];
                this.users.forEach(user => {
                    if (this.hideTokenUsers === false || (this.hideTokenUsers === true && user.is_related_with_token === 0)) {
                        usersOptions.push({
                            text: user.login,
                            id: user.id
                        });
                    }
                });
                return usersOptions;
            }
        },

        beforeMount() {

        },

        created () {
            this.eventHub.$on('submit-form', (stay) => {
                this.stayOnPage = stay;
                this.onSubmit();
            })
        },

        beforeDestroy () {
            this.eventHub.$off('submit-form')
        },

        methods: {
            onSubmit() {
                if (this.formType === 'edit') {
                    this.form.put(route('user::user-groups.update', {id: this.userGroup.id}))
                        .then((response) => {
                            if (this.stayOnPage) {
                                this.eventHub.$emit('processing-finish');
                                this.eventHub.$emit('toast-notification', response.message, 'success');
                            } else {
                                window.location.href = route('user::user-groups.index') + '?status-message=success:' + response.message;
                            }
                        })
                        .catch(this.onResponseError);
                } else {
                    this.form.post(route('user::user-groups.store'))
                        .then((response) => {
                            if (this.stayOnPage) {
                                window.location.href = route('user::user-groups.edit', {id: response.data.userGroup.id}) + '?status-message=success:' + response.message;
                            } else {
                                window.location.href = route('user::user-groups.index') + '?status-message=success:' + response.message;
                            }
                        })
                        .catch(this.onResponseError);
                }
            },

            onResponseError(response) {
                this.eventHub.$emit('processing-finish');
                this.eventHub.$emit('toast-notification', 'Coś poszło nie tak. Sprawdź poprawność danych.', 'error');
            }
        }
    }

</script>

<style scoped>

</style>
